module.exports = __webpack_public_path__ + "img/corrugatedBox10.b9b99d4b.jpg";